import {Outlet} from 'react-router-dom';
import {SidebarInset, SidebarProvider} from '@common-web/components/ui/sidebar';
import {AppSidebar} from '@internal/components/app-sidebar';
import {useTenantTheme} from '@common-web/providers/tenantThemeProvider';
import {cn} from '@common-web/lib/utils';

const DEFAULT_CONTENT_CLASS = 'flex flex-1 flex-col bg-background rounded-xl';

export function Layout() {
  const {layout, logo} = useTenantTheme();

  return (
    <SidebarProvider
      style={
        {
          '--sidebar-width': 'calc(var(--spacing) * 72)',
          '--header-height': 'calc(var(--spacing) * 12)',
        } as React.CSSProperties
      }
    >
      <AppSidebar variant='inset' logo={logo} />
      <SidebarInset>
        <div className={cn(DEFAULT_CONTENT_CLASS, layout?.contentClassName)}>
          <div className='@container/main flex flex-1 flex-col rounded-lg m-1 overflow-clip'>
            <Outlet />
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
